import { AppThunk } from "./store";
import {
  SET_SELECT_NETWORK_MODAL_STATUS,
  SET_SELECT_WALLET_MODAL_STATUS,
} from "./modalSlice";

export const setSelectWalletModalStatus =
  (status: boolean): AppThunk =>
  async (dispatch) => {
    dispatch(SET_SELECT_WALLET_MODAL_STATUS(status));
  };

export const setSelectNetworkModalStatus =
  (status: boolean): AppThunk =>
  async (dispatch) => {
    dispatch(SET_SELECT_NETWORK_MODAL_STATUS(status));
  };
